import type { Category } from '../../components/agent/scheduleDay'
import { SHIFT_TEMPLATE } from '../agent/scheduleDefaults'

export type BoardCode = {
  code: string
  category: Category
  label: string
  detail?: string
}

/**
 * docs/design/journey-map.md's "Planning board": "Type a code straight into
 * a focused cell: typing opens an autocomplete over the status and
 * assignment codes." The status codes are
 * docs/product/scheduling-model.md's own catalog; the assignment codes are
 * the ones already in this pilot's schedule data (payPeriod19.ts), applied
 * as a scheduled workday carrying that assignment, the same shape a real
 * work entry already has: a status and, for work, an assignment (see
 * "Schedule entry"). There is no destination on a detail code, and no
 * shift or leave-type detail beyond what is listed here, since the fuller
 * per-day editing form is not built.
 */
export const BOARD_CODES: BoardCode[] = [
  { code: 'Scheduled workday', category: 'work', label: SHIFT_TEMPLATE.time },
  { code: 'Regular day off', category: 'off', label: 'Regular day off' },
  { code: 'Annual leave', category: 'leave', label: 'Annual leave' },
  { code: 'Sick leave', category: 'leave', label: 'Sick leave' },
  { code: 'Other approved absence', category: 'leave', label: 'Other approved absence' },
  { code: 'Training', category: 'training', label: '0800–1600 · Training' },
  { code: 'Academy', category: 'training', label: '0800–1600 · Academy', detail: 'Firearms requalification' },
  { code: 'Temporary duty', category: 'detail', label: 'Temporary duty' },
  { code: 'Detailed out', category: 'detail', label: 'Detailed out' },
  { code: 'Administrative duty', category: 'work', label: SHIFT_TEMPLATE.time, detail: 'Administrative duty' },
  { code: 'Court', category: 'work', label: SHIFT_TEMPLATE.time, detail: 'Court' },
  { code: 'Alternate duty', category: 'work', label: SHIFT_TEMPLATE.time, detail: 'Alternate duty' },
  { code: 'Unavailable', category: 'unavailable', label: 'Unavailable' },
  { code: 'Case Processing', category: 'work', label: SHIFT_TEMPLATE.time, detail: 'Case Processing' },
  { code: 'Intake', category: 'work', label: SHIFT_TEMPLATE.time, detail: 'Intake' },
  { code: 'Transport', category: 'work', label: SHIFT_TEMPLATE.time, detail: 'Transport' },
  {
    code: 'Fugitive Operations · Team 3',
    category: 'work',
    label: SHIFT_TEMPLATE.time,
    detail: 'Fugitive Operations · Team 3',
  },
]
